import type { JsonObject } from "@inf-monkeys-tech/monkeys";
import type { CapabilityTranslate, CapabilityTranslateValues } from "./contracts";

export const TABLE_MESSAGE_VALUE_SCHEMA: JsonObject = {
  type: "object",
  additionalProperties: false,
  required: ["key"],
  properties: {
    key: { type: "string", minLength: 1 },
    values: {
      type: "object",
      additionalProperties: { type: ["string", "number", "boolean"] },
    },
  },
};

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value) &&
  (Object.getPrototypeOf(value) === Object.prototype || Object.getPrototypeOf(value) === null);

/** Translate an explicitly typed message cell; never infer messages from ordinary objects. */
export function renderTableMessageValue(value: unknown, translate: CapabilityTranslate): string {
  if (!isRecord(value) || typeof value.key !== "string" || value.key.length === 0 ||
      Object.keys(value).some((key) => key !== "key" && key !== "values")) {
    throw new TypeError("Invalid table message value");
  }
  if (value.values !== undefined && (!isRecord(value.values) ||
      Object.values(value.values).some((item) =>
        typeof item !== "string" && typeof item !== "boolean" &&
        !(typeof item === "number" && Number.isFinite(item))))) {
    throw new TypeError("Invalid table message interpolation values");
  }
  return translate(value.key, value.values as CapabilityTranslateValues | undefined);
}
